export default {
    upgrade: {
        title: '选择适合您的计划',
        subtitle: '解锁专业功能，提升您的生产力',
        pickYourPlan: '选择计划',
        subscribeSuccess: '订阅成功',
        contactSales: '请联系我们的销售团队以获取企业解决方案。',
        enterpriseRestriction: '当前仅支持个人用户订阅付费套餐，企业用户如需使用请联系销售团队获取专属方案。',
        freeplanActivated: '基础版已激活',
        planNotFound: '未找到所选套餐',
        alreadySubscribed: '您已经订阅了此计划',
        priceIdNotConfigured: '该套餐暂未配置支付信息',
        paymentInitFailed: '支付初始化失败，请重试',
        plans: {
            period: {
                monthly: ' / 月',
                yearly: ' / 年',
            },
            basic: {
                name: '基础版',
                subtitle: '入门必备核心功能',
                price: '免费',
                description: '一站式体验 AI 智能体全流程专利检索与撰写服务',
                button: '立即开始',
                featuresHeader: '方案功能：',
            },
            pro: {
                name: '专业版',
                subtitle: '专业人士的高级工具',
                description: '加速专利申请全流程工作流',
                button: '订阅专业版',
                moduleName: '专业版（月付/年付）',
                yearlySavings: '年付更优惠',
                featuresHeader: '全球专利申请全流程撰写辅助功能：',
                features: {
                    additionalHiroMessages: '额外 Hiro Copilot 对话次数',
                    fullDocumentExports: '完整文档导出',
                    disclosure1Doc: '发明披露文件生成 ({n}篇)',
                    application1Doc: '专利申请文件撰写 ({n}篇)',
                    oar1Doc: '审查意见答复 ({n}篇)',
                },
            },
            enterprise: {
                name: '企业版',
                subtitle: '为组织提供全面的智能支持',
                price: '联系我们',
                description: '为企业提供全维度知识产权保护方案',
                button: '预约演示',
                featuresHeader: '包含撰写专业版全部功能，额外新增：',
                features: {
                    securityHeader: '安全与管控',
                },
                benefits: {
                    expandedSearch: '检索量扩容',
                    humanInLoop: '人机协同校验',
                    advancedEditor: '高级在线编辑器',
                    workspaceIntegration: '团队工作空间集成',
                    professionalExport: '专业文档导出',
                    evenMoreHiro: '更多 Hiro Copilot 对话次数',
                    ssoSecurity: 'SSO 单点登录与高级安全配置',
                    dedicatedSuccess: '专属客户成功经理',
                },
            },
            api: {
                name: 'API',
                subtitle: '开发者优先的集成方案',
                price: '定制化报价',
                description: '知识产权情报能力无缝集成',
                button: '了解更多',
                featuresHeader: '包含专业版，以及：',
                features: {
                    unifiedAiDataLoop: '可落地的 AI - 数据闭环洞察能力',
                    instantIntegration: '模块化组件与 SDK 快速集成',
                    predictableScaling: '透明用量模式，可预测的弹性扩容',
                    infrastructure: '企业级基础设施，99.9% 服务等级协议 (SLA)',
                    connectivity: '主流技术栈通用适配',
                    support: '主动支持与健康监控',
                },
            },
            features: {
                hiroMessages: 'Hiro Copilot 对话交互',
                disclosure: '发明披露文件生成',
                application: '专利申请文件撰写',
                oar: '审查意见答复',
                templateInstructionStyle: '模板 / 指令 / 格式自定义',
                wordWpsPlugin: 'Word 插件（即将发布）',
            },
        },
        billingCycle: {
            monthly: '月付',
            yearly: '年付',
            saveAmount: '省 $ {amount}',
        },
        features: '方案功能',
        benefits: '权益',
        recommend: '推荐',
        comparison: {
            title: '对比套餐',
            plans: {
                guest: '访客',
                free: '基础版',
                pro: '专业版',
                enterprise: '企业版',
            },
            categories: {
                agent: '核心 Agent',
                features: '其他功能',
                ai: 'AI 工具',
                security: '安全与管控',
                collaboration: '企业协作',
            },
            rows: {
                disclosure: '发明披露文件生成',
                application: '专利申请文件撰写',
                oar: '审查意见答复',
                templates: '模板',
                instructions: '指令',
                styles: '风格',
                draftingCenter: '撰写中心',
                officePlugin: 'Word 插件（即将发布）',
                aiChat: 'Hiro',
                chatLimitN: '{n} 次/天',
                chatLimit500: '500 次/天',
                moreUsage: '更高的次数',
                evenMoreUsage: '定制次数',
                createProject: '创建项目',
                exportProject: '导出项目',
                sharedAssets: '模板/指令/风格共享',
                enterpriseManagement: '企业管理',
            },
        },
    },
    pricing: {
        payment: {
            creatingSession: '正在创建支付会话...',
            errors: {
                createSessionFailed: '创建支付会话失败，请检查当前账号类型。',
                verifyFailed: '验证支付状态失败',
                verificationFailed: '支付验证失败',
                verificationError: '验证过程中发生错误',
                invalidCallback: '无效的支付回调',
                noPriceId: '价格信息未配置',
            },
        },
    },
};
